// extracted by mini-css-extract-plugin
export default {"w-full":"Promote_w-full__M+-lF","card":"Promote_card__ev7aW"};